import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';

import MenuItemIcon from './MenuItemIcon';
import { graff } from '../../graff';

const { color } = graff;

const useStyles = makeStyles({
  root: {
    borderRadius: 12,
    margin: '2px 0',
    padding: '5px 3px',
    color: color.muted,
    transition: 'background-color .2s, color .2s, box-shadow .2s',
    '&:hover': {
      backgroundColor: color.sunken,
      color: color.ink,
    },
  },
  selected: {
    backgroundColor: color.surface,
    color: color.ink,
    boxShadow: graff.shadow.sm,
    '&:hover': {
      backgroundColor: color.surface,
    },
    '& $icon': {
      backgroundColor: color.cyanSoft,
      color: color.cyanInk,
    },
  },
  logout: {
    '&:hover': {
      backgroundColor: 'rgba(215,38,61,.06)',
      color: color.danger,
    },
  },
  itemIcon: {
    minWidth: 0,
    marginRight: 12,
    color: 'inherit',
  },
  // The icon in its small rounded square.
  icon: {
    width: 30,
    height: 30,
    borderRadius: 9,
    display: 'grid',
    placeItems: 'center',
    color: 'inherit',
    transition: 'background-color .2s, color .2s',
    '& svg': {
      fontSize: 18,
    },
  },
  text: {
    margin: 0,
  },
  label: {
    fontFamily: graff.font.body,
    fontWeight: 600,
    fontSize: 14,
    whiteSpace: 'nowrap',
  },
});

const RootMenuItem = (props) => {
  // props
  const { label, name, selected, onClick } = props;

  // styles
  const classes = useStyles();

  const _onClick = () => {
    onClick && onClick(name);
  };

  return (
    <ListItem
      button
      key={label}
      onClick={_onClick}
      className={classNames(classes.root, {
        [classes.selected]: selected,
        [classes.logout]: name === 'logout',
      })}
    >
      <ListItemIcon className={classes.itemIcon}>
        <span className={classes.icon}>
          <MenuItemIcon name={name} />
        </span>
      </ListItemIcon>
      <ListItemText primary={label} className={classes.text} classes={{ primary: classes.label }} />
    </ListItem>
  );
};

RootMenuItem.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  isVisible: PropTypes.bool,
  selected: PropTypes.bool,
};

export default RootMenuItem;
